import { Button, DefaultPageSection, PaginaInicialTimeline } from '../components';
import { EnvironmentEnum, LayoutEnum } from '../enums';
import React, { FunctionComponent, useEffect } from 'react';
import { useAuth, useLayout } from '../hooks';

import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const PaginaInicialView: FunctionComponent = () => {
  const { t } = useTranslation();
  const auth = useAuth();
  const navigate = useNavigate();
  const { setLayout } = useLayout();

  useEffect(() => {
    setLayout(LayoutEnum.LANDING_PAGE_LAYOUT);
  }, []);

  return (
    <div>
      <PaginaInicialTimeline id={'passos-sistema'} />

      <div className="page-section-columns d-flex">
        <DefaultPageSection
          heading={t('label.iniciar_cadastro')}
          subheading={t('texto.apresentacao_sce_iniciar_cadastro')}
          id={'cadastro'}
          columns
        >
          <Button
            title={t('label.cadastrar')}
            onClick={() => {
              if (process.env.REACT_APP_ENV === EnvironmentEnum.REVIEW_APP) {
                auth.login(() => navigate('/eleicoes'));
              } else {
                window.location.href = `${process.env.REACT_APP_AUTHSERVER_URL}/oauth/authorize?client_id=sce&scope=personal-read&response_type=code&redirect_uri=${process.env.REACT_APP_REDIRECT_URL}`;
              }
            }}
          />
        </DefaultPageSection>
        <div className="vr d-none d-md-block" />
        <DefaultPageSection
          heading={t('label.ajuda_cadastro')}
          subheading={t('texto.apresentacao_sce_instrucoes')}
          id={'instrucoes'}
          columns
          bgWhite
        >
          <Button
            title={t('label.visualizar_manual')}
            onClick={() => {
              window.open('https://conhecimento.sti.ufpb.br/books/sistema-de-cadastro-de-eleicoes', '_blank');
            }}
          />
        </DefaultPageSection>
      </div>
    </div>
  );
};

export default PaginaInicialView;
